import { useRef } from "react";
import "../../style/PhoneInput.css";

// phone input with auto-advance: xxx - xxx - xxxx
function PhoneInput({ value = "", onChange, disabled = false }) {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);

  // parse value into parts
  const digits = (value || "").replace(/\D/g, "");
  const part1 = digits.slice(0, 3);
  const part2 = digits.slice(3, 6);
  const part3 = digits.slice(6, 10);

  const handleChange = (part, newVal, nextRef) => {
    const cleaned = newVal.replace(/\D/g, "");
    
    let newParts;
    if (part === 1) {
      newParts = [cleaned.slice(0, 3), part2, part3];
      if (cleaned.length >= 3 && nextRef) nextRef.current?.focus();
    } else if (part === 2) {
      newParts = [part1, cleaned.slice(0, 3), part3];
      if (cleaned.length >= 3 && nextRef) nextRef.current?.focus();
    } else {
      newParts = [part1, part2, cleaned.slice(0, 4)];
    }

    const fullNumber = newParts.join("");
    // format as (xxx) xxx-xxxx if complete
    if (fullNumber.length === 10) {
      onChange(`(${newParts[0]}) ${newParts[1]}-${newParts[2]}`);
    } else {
      onChange(fullNumber);
    }
  };

  const handleKeyDown = (e, part, prevRef) => {
    if (e.key === "Backspace" && e.target.value === "" && prevRef) {
      prevRef.current?.focus();
    }
  };

  return (
    <div className="phone-input-wrapper">
      <input
        ref={ref1}
        type="text"
        inputMode="numeric"
        maxLength={3}
        value={part1}
        onChange={(e) => handleChange(1, e.target.value, ref2)}
        onKeyDown={(e) => handleKeyDown(e, 1, null)}
        placeholder="000"
        disabled={disabled}
        className="phone-input-segment"
      />
      <span className="phone-input-separator">-</span>
      <input
        ref={ref2}
        type="text"
        inputMode="numeric"
        maxLength={3}
        value={part2}
        onChange={(e) => handleChange(2, e.target.value, ref3)}
        onKeyDown={(e) => handleKeyDown(e, 2, ref1)}
        placeholder="000"
        disabled={disabled}
        className="phone-input-segment"
      />
      <span className="phone-input-separator">-</span>
      <input
        ref={ref3}
        type="text"
        inputMode="numeric"
        maxLength={4}
        value={part3}
        onChange={(e) => handleChange(3, e.target.value, null)}
        onKeyDown={(e) => handleKeyDown(e, 3, ref2)}
        placeholder="0000"
        disabled={disabled}
        className="phone-input-segment phone-input-segment-last"
      />
    </div>
  );
}

export default PhoneInput;
